module.exports = __webpack_public_path__ + "static/media/garden-waste.b6feed67.svg";